<template>
	<div class="ks-videoeditor-controls">
		<k-btn size="m" icon icon-name="first_page" :disabled="end_time <= 0" @click="$emit('rewind')"></k-btn>
		<k-btn size="m" color="primary" icon :icon-name="playing ? 'pause' : 'play_arrow'" :disabled="end_time <= 0" @click="$emit('toggle')"></k-btn>
		<span class="ks-videoeditor-time"><span ref="time_label">{{ fmt(playhead) }}</span> / {{ fmt(end_time) }}</span>
		<span class="ks-videoeditor-spacer"></span>
		<k-checkbox v-model="low" label="Low quality preview" title="Plays the lowest available quality in the preview; the saved timeline keeps each clip's chosen quality"></k-checkbox>
	</div>
</template>

<script>
import {fmt} from './utils.js'

export default {
	props: {
		playing: Boolean,
		playhead: Number,
		end_time: Number,
		preview_low: Boolean
	},
	computed: {
		low: {
			get () {
				return this.preview_low;
			},
			set (value) {
				this.$emit("update:preview_low", value);
			}
		}
	},
	methods: {
		fmt,
		// While playing the time is not reactive; writing nodeValue keeps the text node Vue owns, so the next render still patches it
		show_time (time) {
			const label = this.$refs.time_label;
			if (label && label.firstChild) label.firstChild.nodeValue = fmt(time);
		}
	}
}
</script>

<style scoped>
.ks-videoeditor-controls { display: flex; align-items: center; gap: 8px; margin-top: 8px; }
.ks-videoeditor-time { font-variant-numeric: tabular-nums; margin-left: 8px; }
</style>
